<template>
  <div class="page-home">

    <div :class="['home-page-style pt-4',{'bg-start':mark_play === false}]">
      <div class="home-banner-box">
        
        <span
          v-if="mark_play === false"
          @click="action_playnow()"
          class="sp-btn">
          {{lg('',{
            en: 'Play',
            zh: '开始',
          })}}
          <br>
          {{lg('',{
            en: 'Now',
            zh: '游戏',
          })}}
        </span>

        <span
          v-else-if="$store.state.web3.status_hasApproveMint_lion == false"
          @click="action_approve()"
          class="sp-btn">
          {{lg('',{
            en: 'Approve',
            zh: 'Approve 批准',
          })}}
        </span>
        <span
          v-else
          @click="action_draw()"
          class="sp-btn">
          {{lg('',{
            en: 'Draw',
            zh: '抽狮子',
          })}}
        </span>
      </div>

      <div v-if="mark_play === true" class="home-tips">
        <p>
          {{lg('',{
            en: 'Welcome to the JuggyLAND mystic fountain, where magic lions are born. Are you ready to embark on an adventure and lead your lions to the kingdom throne?',
            zh: '神秘喷泉，这里是魔法狮子的诞生地。您准备好开始冒险并带领您的狮子登上王国宝座了吗？',
          })}}
        </p>
        <p class="mt-3">
          {{lg('',{
            en: 'Connect your wallet and claim your LIMITED GEN 0 lions!',
            zh: '连接钱包，现在就开始抽取你特有的限量版的创世代的狮子吧！',
          })}}
        </p>
      </div>
    </div>

    <!-- lion left -->
    <div class="lion-left-box">
      <div class="sp-num-box">
        <div class="num text-center" style="min-width: 100px;">
          {{num_mint_counter}}
        </div>
      </div>
    </div>

    <!-- big text -->
    <div class="ui-uni-bg-01 py-5">
      <div class="container" style="max-width: 1100px;">
        <div class="sp-home-show">

          <div class="d-flex p-3">
            <div style="width: 340px;">
              <img src="/static/img/page_home_demo_lion.png?v2">
            </div>
            <div class="ml-5">
              <h1 class="my-3 b">
                {{lg('',{
                  en: 'Who will rule JuggyLAND?',
                  zh: '谁来统治JuggyLAND？',
                })}}
              </h1>
              <p>
                {{lg('',{
                  en: 'Who will be the next prince or princess of JuggyLAND?',
                  zh: '谁将是JuggyLAND下一个王子或公主？',
                })}}
              </p>
              <p>
                {{lg('',{
                  en: 'These young lions may look cute and cuddly, but they certainly can bite! ',
                  zh: '虽然这些小狮子看起来十分可爱，但它们战斗力爆表！',
                })}}
              </p>
              <p>
                {{lg('',{
                  en: 'JuggyLAND is the play-to-earn metaverse game that lets you collect, breed and battle young lions to earn JGN tokens! ',
                  zh: 'JuggyLAND是一款全新的 Metaverse 游戏，采用全新的战斗系统，让玩家通过收集、战斗和繁殖（幼狮）来赚取JGN代币！',
                })}}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- block -->
    <div class="container" style="max-width: 1200px;">
      <div class="d-flex flex-wrap justify-content-around mt-5">

        <!-- link 1 -->
        <router-link 
          :to="{name: 'explore'}"
          class="sp-home-link-box mb-5 mx-2 op7"
          >
          <div class="item-border">
            <div class="sp-icon-block">
              <span class="ui-icon size-60 sp-icon">
                <img src="/static/img/icon_paw.png">
              </span>
            </div>
            <div class="sp-title">
              {{lg('',{
                en: 'COLLECT',
                zh: '收集',
              })}}
            </div>
            <div class="sp-text">
              <p>
                {{lg('',{
                  en: 'Get your favourite Juggy lions, either claiming them from the mystical fountain or buying them in the open  market. ',
                  zh: '可以从神秘的喷泉中获得或在公开市场购买您最喜欢的Juggy狮子！',
                })}}
              </p>
              <p>
                {{lg('',{
                  en: 'Each Juggy is exclusive, with unique characteristics!',
                  zh: '每个Juggy狮子都是独一无二的，都具有各自鲜明的特征！',
                })}}
              </p>
            </div>
          </div>
        </router-link>

        <!-- link 2 -->
        <router-link 
          :to="{name: 'breeding'}"
          class="sp-home-link-box mb-5 mx-2 op8"
          >
          <div class="item-border">
            <div class="sp-icon-block">
              <span class="ui-icon size-60 sp-icon">
                <img src="/static/img/icon_hearts.png">
              </span>
            </div>
            <div class="sp-title">
              {{lg('',{
                en: 'BREED',
                zh: '繁殖',
              })}}
            </div>
            <div class="sp-text">
              <p>
                {{lg('',{
                  en: 'Are you looking to create the next heir to the lion throne? Or a cute little lion that will become the most charming animal in the kingdom?',
                  zh: '您是否希望创造狮子王国的下一个继承人？或者是一只可爱的小狮子，它将成为王国中最迷人的动物?',
                })}}
              </p>
              <p>
                {{lg('',{
                  en: 'Either way, it’s time to create baby lions!',
                  zh: '无论哪种方式，可以开始创造小狮子了。',
                })}}
              </p>
            </div>
          </div>
        </router-link>

        <!-- link 3 -->
        <router-link 
          :to="{name: 'race_list'}"
          class="sp-home-link-box mb-5 mx-2"
          >
          <div class="item-border">
            <div class="sp-icon-block">
              <span class="ui-icon size-60 sp-icon">
                <img src="/static/img/icon_sword.png">
              </span>
            </div>
            <div class="sp-title">
              {{lg('',{
                en: 'FIGHT',
                zh: '战斗',
              })}}
            </div>
            <div class="sp-text">
              <p>
                {{lg('',{
                  en: 'Juggy lions will fight to claim the right to rule the kingdom!',
                  zh: '凶猛的狮子会为争夺统治王国的权利而战!',
                })}}
              </p>
              <p>
                {{lg('',{
                  en: 'Participate in fierce combats, where only the strongest survive. ',
                  zh: '参加激烈的战斗，只有最强者才能生存。',
                })}}
              </p>
              <p>
                {{lg('',{
                  en: 'Are you ready for war?',
                  zh: '准备好战斗了吗？',
                })}}
              </p>
            </div>
          </div>
        </router-link>

      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
export default {
  name: 'home',
  components: {
  },
  props: [],
  data() {
    return {
      num_mint_counter: '-'
    }
  },
  computed: {
    address_my(){
      return this.$store.state.web3.account
    },
    mark_play(){
      return this.$store.state.app.mark_homepage_play_now
    },
  },
  watch: {
    address_my(){
      this.checkApploveLion()
    },
  },
  methods: {
    ...mapActions([
      'hasApproveMint',
      'approveMint',
      'mintLion',
      'getMintcounter',
      'getMintResult',
    ]),

    async action_getMintcounter(){
      let res = await this.getMintcounter()
      this.num_mint_counter = res
    },

    action_playnow(){
      this.$store.commit('setAppKey',{
        'mark_homepage_play_now': true,
      })
    },
    async action_approve(){
      let v = this
      if(!v.address_my){
        return
      }
      let res  = await v.approveMint({
        address_my: v.address_my,
      })

      console.log(res)

      if(res){
        v.checkApploveLion()
      }
    },
    async action_draw(){
      let v = this
      if(!v.address_my){
        return
      }

      v.$store.commit('setAppKey',{is_app_loading: 'bg-draw'})

      try{

        let res = await v.mintLion({
          address_my: v.address_my,
        })
        v.$store.commit('setAppKey',{is_app_loading: false})
        if(res){

          v.$store.commit('setAppKey',{is_app_loading: 'bg-draw'})
          let obj = await v.getMintResult(v.address_my)
          v.$store.commit('setAppKey',{is_app_loading: false})

          // console.log('draw res:' + obj)
          v.$store.commit('setDataBusKey',{
            data_popup_show_new_draw: obj,
          })
        }
      }
      catch{
        v.$store.commit('setAppKey',{is_app_loading: false})
      }
    },
    async checkApploveLion(){
      let v = this
      if(!v.address_my){
        return
      }

      if(v.$store.state.web3.status_hasApproveMint_lion){
        return
      }

      let res = await v.hasApproveMint({
        address_my: v.address_my,
      })
      console.log(res)
      if(res){
        v.$store.commit('setWeb3Data',{
          status_hasApproveMint_lion: true
        })
      }
    },
    run(){
      this.checkApploveLion()
      this.action_getMintcounter()
    },
  },
  created() {
    this.run()
    return
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/vars.scss';

  .page-home{

    .home-banner-box{
      margin: auto;
      width: 350px;
      height: 230px;
      padding-top: 165px;
      background: url('/static/img/bg_home_v2_banner_b.png');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center top;
      text-align: center;

      .sp-btn{
        display: block;
        margin: 0 auto;
        width: 70px;
        height: 60px;
        
        display: flex;
        align-items: center;
        justify-content: center;

        line-height: 20px;

        color: $c2;
        cursor: pointer;
        font-weight: bold;
        font-size: 18px;
        font-family: 'Times New Roman', Times, serif;

        &:hover{
          text-shadow: 0 0 5px rgba($c,0.8);
        }
      }
    }

    // 背景图
    .home-page-style {
      height: 100vh;
      height: calc( 100vh - 50px);
      @media(max-width: 789px){
        height: calc( 48vh );
      }
      background: url('/static/img/bg_home_v5.jpg?b') center center no-repeat;
      background-size: cover;
      background-color: #73529A;
      #app.theme-light,#app.theme-dark{
        background-color: transparent !important;
      }
      .site-footer{
        display: none;
      }

      &.bg-start{
        background-image: url('/static/img/bg_home_start_v1.jpg?b');
      }
    }

    .home-tips{
      padding: 20px 30px;
      margin: 0 auto;
      margin-top: 10px;
      width: 350px;
      color: #fff;
      text-align: center;
      font-size: 13px;
      line-height: 16px;
      background-color: rgba(mix($c,#999,80),0.9);
      p{
        margin-bottom: 5px;
      }
    }

    // lion-left
    .lion-left-box{
      background-color: $c;
      height: 240px;
      background: linear-gradient(180deg, $c, adjust-hue($c, -30deg) );
      padding: 20px 0;

      .sp-num-box{
        background: url('/static/img/bg_home_lion_num.png');
        background-size: contain;
        width: 400px;
        max-width: 100%;
        height: 200px;
        margin: 0 auto;
        background-position: center center;
        background-repeat: no-repeat;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 30px;

        .num{
          font-size: 46px;
          background-color: darken($c, 15);
          color: #fff;
          font-family: verdana;
          letter-spacing: 12px;
          padding: 15px 20px;
          padding-left: 28px;
          display: inline-block;
        }
      }
    }

    // 
    .sp-home-show{
      min-height:310px;
      border-radius: 20px;
      background-color: #fff;

      @media(min-width: 789px){
        border-radius: 150px;
      }
    }

    // 
    .sp-home-link-box{
      display: block;
      background-color: $c;
      padding: 25px;
      width: 300px;
      color: #fff;
      text-align: center;

      &:hover{
        color: #fff !important;
      }

      .item-border{
        border: 4px solid #fff;
        padding: 20px;
      }
      .sp-icon-block{
        text-align: center;

        .sp-icon{
          img{
            object-fit: contain;
          }
          border: 3px solid #fff;
          padding: 10px;
          margin-bottom: 10px;
        }
      }

      .sp-title{
        background-color: #fff;
        margin: 0  -50px;
        color: $c;
        font-weight: bold;
        font-size: 24px;
        height: 40px;
        line-height: 40px;
      }

      .sp-text{
        min-height: 180px;
        padding-top: 10px;
        font-size: 12px;
        line-height: 20px;

        p{
          &:last-child{
            margin-bottom: 0;
          }
        }
      }
    }

  }
</style>